export const CREATE_CATEGORY_REQUEST = 'category/CREATE_REQUEST';
export const CREATE_CATEGORY_SUCCESS = 'category/CREATE_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'category/CREATE_FAILURE';
